import React, { useEffect, useRef, useState } from "react";
import { FaKeyboard } from "react-icons/fa";

import "./shortcuts-hint.css";

const SHORTCUTS = [
	{ keys: ["Ctrl/⌘", "Z"], label: "Voltar (desfazer)" },
	{ keys: ["Ctrl", "Y"], label: "Avançar (refazer)" },
	{ keys: ["Ctrl/⌘", "C"], label: "Copiar ação(ões) selecionada(s)" },
	{ keys: ["Ctrl/⌘", "V"], label: "Colar ação(ões)" },
	{ keys: ["Ctrl/⌘", "K"], label: "Buscar ação" },
];

export default function ShortcutsHint() {
	const [open, setOpen] = useState(false);
	const ref = useRef(null);

	useEffect(() => {
		if (!open) return;
		const onDocPointerDown = (e) => {
			if (ref.current && !ref.current.contains(e.target)) setOpen(false);
		};
		// fase de captura: fecha mesmo se o canvas do reactflow parar a propagação
		document.addEventListener("pointerdown", onDocPointerDown, true);
		return () =>
			document.removeEventListener("pointerdown", onDocPointerDown, true);
	}, [open]);

	return (
		<div className="shortcuts-hint" ref={ref}>
			<button
				type="button"
				className="shortcuts-hint__btn"
				title="Atalhos do teclado"
				onClick={() => setOpen((o) => !o)}
			>
				<FaKeyboard />
			</button>

			{open && (
				<div className="shortcuts-hint__pop">
					<div className="shortcuts-hint__title">Atalhos do teclado</div>
					{SHORTCUTS.map((s, i) => (
						<div className="shortcuts-hint__row" key={i}>
							<span className="shortcuts-hint__keys">
								{s.keys.map((k, j) => (
									<kbd key={j}>{k}</kbd>
								))}
							</span>
							<span className="shortcuts-hint__label">{s.label}</span>
						</div>
					))}
				</div>
			)}
		</div>
	);
}
